export default __webpack_public_path__ + "static/media/file-checklist-edit.4f5afad2.svg";